import { BLOCK_TYPES, FIELD_TYPES } from '@client/components/Block/constants'

export const defaultText = {
  question: 'Write your question here...',
  helpText: 'Please be as honest as possible',
}

export const defaultSettings = {
  type: BLOCK_TYPES.FIELD,
  fieldType: FIELD_TYPES.SINGLE_CHOICE,
  question: defaultText.question,
  isRequired: false,
  hasHelpText: false,
  helpText: defaultText.helpText,
}
